export default __webpack_public_path__ + "static/media/ray.8cb72c9e.jpg";